import React from 'react';
import ReactDOM from 'react-dom';
import { configure} from 'mobx';
import { Provider, observer } from 'mobx-react';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import { syncHistoryWithStore } from "@superwf/mobx-react-router";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import localeFi from 'date-fns/locale/fi'
import authStore from './stores/authStore';
import homeStore from './stores/homeStore';
import tulosStore from './stores/tulosStore';
import tasevastaavaaStore from './stores/tasevastaavaaStore';
import tasevastattavaaStore from './stores/tasevastattavaaStore';
import laskuStore from './stores/laskuStore';
import omaveroStore from './stores/omaveroStore';
import ostolaskuStore from './stores/ostolaskuStore';
import receiptStore from './stores/receiptStore';
import routing from './stores/routingStore';
import viewStore from './stores/viewStore';
import tilikausiStore from './stores/tilikausiStore';
import App from './App';
import './index.css';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import pink from '@material-ui/core/colors/pink';
import red from '@material-ui/core/colors/red';


export const browserHistory = createBrowserHistory({
  basename: process.env.REACT_APP_BASENAME
});

export const history = syncHistoryWithStore(browserHistory, routing);

configure({
    enforceActions: "observed"
});

export const theme = createTheme({
  palette: {
    primary: {
      main: red[600],
    },
    secondary: {
      main: pink.A400,
    },
    // error: {
    //   main: red[500],
    // },
  },
});

export const stores = {
  routing,
  authStore,
  homeStore,
  tasevastaavaaStore,
  tasevastattavaaStore,
  tulosStore,
  laskuStore,
  omaveroStore,
  ostolaskuStore,
  receiptStore,
  viewStore,
  tilikausiStore
};

export const Application =  observer(() => {
  return (
  <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeFi}>
        <Provider {...stores}>
          <Router history={history}>
            <App />
          </Router>
        </Provider>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
      );
    });


ReactDOM.render(
  <Application />,
  document.getElementById('root') || document.createElement('div')
);


